import Emitter from "es6-event-emitter";
import { REACHED_REDIRECT_LIMIT } from "./../../common/analytics/analyticsevents";
// this class will implement al UI necessary to authenticate users
// and authorize downloads.
import {
  isParameterInUrl,
  sendMessageIfBackButtonEnabled,
} from "./../utilities/utils";

import { EErrorType } from "./../utilities/enums";

import ExternalPaywall from "./externalPaywall";
import { hideLoaderAndChangeLocation } from "../utilities/location";

export default class DownloadComponent extends Emitter {
  _authenticatorAuthorisationController = null;
  paywall = null;

  constructor(
    authenticatorAuthorisationController,
    paywall,
    options,
    APIManager,
    appState,
    errorPopup = null
  ) {
    // paywallIframeBannerSource    forgotPasswordLink
    super();
    this._authenticatorAuthorisationController =
      authenticatorAuthorisationController;
    this.internalPaywall = paywall;
    this.errorPopup = errorPopup;
    this.options = options;
    this.APIManager = APIManager;
    this._appState = appState;
    this.externalPaywall = new ExternalPaywall(
      paywall,
      options,
      authenticatorAuthorisationController
    );

    this.addEventListeners();
  }

  addEventListeners = () => {
    this.internalPaywall.on("paywall:close", this.onClose);
    this.internalPaywall.on("paywall:authorizeSucces", this.onAuthorizeSucces);
  };

  onAuthorizeSucces = (publicationData) => {
    this.removeEventListeners();
    this.trigger("downloadComponent:succes", publicationData);
  };

  onClose = () => {
    this.removeEventListeners();
    this.trigger("downloadComponent:close");
  };

  onErrorPopupClosed = (publicationData = null, err = null) => {
    this.removeEventListeners(true);
    if (err.type === EErrorType.AUTHORIZATION) {
      if (isParameterInUrl(this.options.showBackButtonParam)) {
        sendMessageIfBackButtonEnabled();
      } else if (this.options.homeRedirectionLink) {
        hideLoaderAndChangeLocation(this.options.homeRedirectionLink, window);
      } else {
        this.trigger("downloadComponent:close");
      }
    } else {
      this._authenticatorAuthorisationController.logOut().catch(() => {
        this.showPaywall(publicationData, false, true);
      });
    }
  };

  validateDownload = (publicationData, confirmdownload, showPaywall = true) => {
    //TODO: confirmdownload

    this._authenticatorAuthorisationController
      .authorize(publicationData, confirmdownload)
      .then(() => {
        this.trigger("downloadComponent:succes", publicationData);
      })
      .catch((err) => {
        if (!showPaywall) {
          this.trigger("downloadComponent:fail", publicationData);
          return;
        }

        if (err) {
          if (
            err.name === "AuthenticationAuthorizationError" &&
            (err.type == EErrorType.AUTHORIZATION ||
              this.options.paywallRedirectionUrl)
          ) {
            this.errorPopup.show(err);
            this.errorPopup.on("errorPopup:close", () => {
              this.onErrorPopupClosed(publicationData, err);
            });
            return;
          }
        }

        this.showPaywall(publicationData, true, false, err);
      });
  };

  showPaywall = (
    publicationData,
    updateNumberOfExternalPaywallRedirection,
    isReauthentication,
    error
  ) => {
    if (!this.options.paywallRedirectionUrl) {
      this.internalPaywall.showWithErrorMessage(error, publicationData, false);
      return;
    }

    if (
      !isReauthentication &&
      this.externalPaywall.currentNumberOfRedirection >=
        this.options.externalPaywallMaxRedirectionNumber
    ) {
      this._appState.triggerEvent(REACHED_REDIRECT_LIMIT);
      this.internalPaywall.showWithErrorMessage(error, publicationData, false);
      return;
    }

    this.externalPaywall.getUrlAndRedirect(
      publicationData,
      updateNumberOfExternalPaywallRedirection
    );
  };

  removeEventListeners = (isErrorPopupListeners = false) => {
    if (isErrorPopupListeners) {
      this.errorPopup.off("errorPopup:close", () => {
        this.onErrorPopupClosed();
      });
    } else {
      this.internalPaywall.off("paywall:close", this.onClose);
      this.internalPaywall.off(
        "paywall:authorizeSucces",
        this.onAuthorizeSucces
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/components/downloadcomponent.js